import React, {useEffect, useRef, useState} from 'react'
import AppRoutes from '../../routes/index'
import {injectIntl} from "react-intl"
import {useDispatch, useSelector} from 'react-redux'
import {checkBannerMessage, getTalent, markBannerMessageAsRead} from '../../redux/actions/Talent'
import {graphqlFullTalentFields} from "../../utils/constant"
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import {userSignOut} from "../../redux/actions/Auth";
import {showLinkedInModal, hideLinkedInModal} from '../../redux/actions/Common'
import {toggleShowRemoteWorkEnvironmentWarning} from '../../redux/actions/Search'
import Button from "@mui/material/Button";
import {TawkToConfig} from "../../utils/tawk_to";
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import CircularProgress from "@mui/material/CircularProgress";
import SearchIcon from '@mui/icons-material/Search';
import {checkAutoProfileFinished} from "../../redux/api/Talent";
import {wait} from "../../utils/compute";
import {checkJob, clearJobId} from "../../redux/actions/Chatgpt";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import {pagesNav, pagesAccNav} from "../../utils/nav_talent";
import Divider from '@mui/material/Divider';
import {capitalizeFirstLetter} from "../../utils/format";
import CreateTicket from '../../components/common/createTicket'
import platformConfig from '../../config/config'
import BannerMessage from '../../components/common/BannerMessage'
import LinkedInModal from '../../components/common/LinkedInModal'



const TalentLayout = ({intl}) => {
    const tawkMessengerRef = useRef();
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const params = useParams()
    const {pathname} = useLocation();
    const {token, user} = useSelector(({auth}) => auth)
    const {talent, reupdate_talent} = useSelector(({talent}) => talent)
    const {documents} = useSelector(({file}) => file)
    const {locale, showLinkedInModal: showLinkedInModalState} = useSelector(({common}) => common)
    const {remoteWorkEnvironmentWarning} = useSelector(({search}) => search)
    const {cguv_en,cguv_fr,protectData_en,protectData_fr} = platformConfig


    const [currentNav, setCurrentNav] = useState("")

    const [newNavigation, setNewNavigation] = React.useState(null);
    const [anchorElDynamic, setAnchorElDynamic] = React.useState(null);
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [openDynamic, setOpenDynamic] = React.useState(null);

    const [showTalkTo, setShowTalkTo] = React.useState(false);

      useEffect(() => {
        dispatch(checkBannerMessage(token));
      }, [dispatch, token]);

    const { name,logoPath,disabledPages } = platformConfig;
    const [bannerMessages, setBannerMessages] = useState(null);
    const [currentMessageIndex, setCurrentMessageIndex] = useState(0);


    // useEffect(() => {
    //     dispatch(checkBannerMessage(token));
    //   }, [dispatch]);

    //   useEffect(() => {
    //     if (bannerMessage && Array.isArray(bannerMessage)) {
    //       const filteredMessages = bannerMessage.filter((msg) => {
    //         const local = localStorage.getItem(`banner_shown_${msg.id}`);
    //         return local !== "true";
    //       });
      
    //       setBannerMessages(filteredMessages);
    //     }
    //   }, [bannerMessage]);

    //   useEffect(() => {
    //     if (bannerMessages && bannerMessages.length > 1) {
    //         const interval = setInterval(() => {
    //             setCurrentMessageIndex((prevIndex) =>
    //                 (prevIndex + 1) % bannerMessages.length
    //             );
    //         }, 10000);
    
    //         return () => clearInterval(interval);
    //     }
    // }, [bannerMessages]);

    //   const currentMessage = bannerMessages && bannerMessages[currentMessageIndex];

    //   console.log(currentMessage,);
      

    // useEffect(() => {
    //     if (bannerMessage) {
    //         setBannerMessages(bannerMessage);
    //     }
    // }, [bannerMessage]);


    // const handleClose = (id) => {
    //     dispatch(markBannerMessageAsRead(token, id));
    //     localStorage.setItem(`banner_shown_${id}`, "true");
    
    //     const filtered = bannerMessages.filter((msg) => msg.id !== id);
    //     setBannerMessages(filtered);
    
    //     if (filtered.length > 0) {
    //         setCurrentMessageIndex((prevIndex) =>
    //             prevIndex >= filtered.length ? 0 : prevIndex
    //         );
    //     }
    // };
    

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };
    const handleCloseNavMenu = (name) => {
        setAnchorElNav(null);
        navigate('/talent/dashboard?tab=' + name);
    };
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };


    const Alert = React.forwardRef(function Alert(
        props, ref,
    ) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const handleTawkTo = () => {
        setShowTalkTo(true);
        setTimeout(function() {
            tawkMessengerRef.current.toggle();
        }, 500);
    }

    useEffect(() => {
        if (user && user.type == 'talent') {
            dispatch(getTalent(token, `
            { 
                talentById(id: "${user.relation}") {
                    ${graphqlFullTalentFields}
                }
            }
        `))
        }

    }, [user, reupdate_talent, documents])

    useEffect(() => {
        if (newNavigation) {
            setTimeout(function() {
                navigate(newNavigation);
                setNewNavigation(null)
            }, 500);
        }

    }, [newNavigation])

    useEffect(() => {
        if (pathname) {
            let allPaths = pagesNav.concat(pagesAccNav);
            for (let i = 0; i < allPaths.length; i++) {
                let path = allPaths[i];
                if (path.subs) {
                    for (let j = 0; j < path.subs.length; j++) {
                        let sub = path.subs[j];
                        if (sub.path === pathname) {
                            setCurrentNav(path.name)
                            return;
                        }
                    }
                }
            }
        } else {
            setCurrentNav("")
        }

    }, [pathname])

    const handleCloseLinkedInModal = () => {
        dispatch(hideLinkedInModal());
    };

    const renderSubs = (subs) => {
        let render = (
            <div style={{minWidth: '180px'}}>
                {subs.map((sub, index) => (
                    <React.Fragment key={index}>
                        <MenuItem
                            className={pathname === sub.path ? 'item-nav bg-secondary text-white hover:text-secondary' : 'item-nav'}
                             onClick={() => {
                            setOpenDynamic(null);
                            setAnchorElUser(null);
                            setNewNavigation(sub.path);
                        }
                        }>
                            {intl.formatMessage({id: sub.name})}
                        </MenuItem>
                        {sub?.break ? <Divider /> : null}
                    </React.Fragment>
                ))}
            </div>
        )

        return render;
    }

    const renderSubsAcc = (subs) => {
        let hideLinks = ['current_invoice', 'invoices'];

        let render = (
            <div style={{minWidth: '180px'}}>
                {subs.map((sub, index) => (
                    (hideLinks.includes(sub.name) && user.employment === 'contractor') || !hideLinks.includes(sub.name) ? (
                    <React.Fragment key={index}>
                        <MenuItem
                            className={pathname === sub.path ? 'item-nav bg-secondary text-white hover:text-secondary' : 'item-nav'}
                             onClick={() => {
                            setOpenDynamic(null);
                            setAnchorElUser(null);
                            setNewNavigation(sub.path);
                        }
                        }>
                            {intl.formatMessage({id: sub.name})}
                        </MenuItem>
                        {sub?.break ? <Divider /> : null}
                    </React.Fragment>
                    ) : ''
                ))}
            </div>
        )

        return render;
    }

    // Add this handler to ensure the modal is always closed properly
    const handleCloseRemoteWorkEnvironmentWarning = () => {
        if (remoteWorkEnvironmentWarning) {
            dispatch(toggleShowRemoteWorkEnvironmentWarning());
        }
    };

    return (
        <div className={'bdj-body-container justify-center relative flex flex-col min-h-screen'} id={'nav_container'}>
            <BannerMessage token={token} />

            {talent && talent?.profile_status != 'new' ?
                <div>
                    <AppBar position="static" className={' bg-white text-secondary'}>
                        <Container maxWidth="xxl">
                            <Toolbar disableGutters>
                                <img
                                    src={logoPath}  alt={`Logo de ${name}`}
                                    className={`ml-16 md:ml-24 flex py-2 cursor-pointer block ${name === "Breedj" ? "w-32" : "w-40"}`}
                                    onClick={() => {
                                        setCurrentNav("")
                                        navigate('/talent/dashboard')
                                    }}
                                />

                                <Box className="flex-grow justify-end text-xl 2md:hidden flex">
                                    <IconButton
                                        size="large"
                                        aria-label="account of current user"
                                        aria-controls="menu-appbar"
                                        aria-haspopup="true"
                                        onClick={handleOpenNavMenu}
                                        color="inherit"
                                    >
                                        <MenuIcon />
                                    </IconButton>
                                    <Menu
                                        id="menu-appbar"
                                        anchorEl={anchorElNav}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        open={Boolean(anchorElNav)}
                                        onClose={() => {
                                            handleCloseNavMenu(null)
                                        }}
                                        sx={{
                                            display: { xs: 'block', md: 'none' },
                                        }}
                                    >
                                        {pagesNav.map((page, index) => (
                                            <MenuItem key={index} onClick={() => {
                                                handleCloseNavMenu(page.name)
                                            }}>
                                                <Typography textAlign="center">{intl.formatMessage({id: page.name})}</Typography>
                                            </MenuItem>
                                        ))}
                                        {pagesAccNav.map((page, index) => (
                                            <MenuItem key={index} onClick={() => {
                                                handleCloseNavMenu(page.name)
                                            }}>
                                                <Typography textAlign="center">{intl.formatMessage({id: page.name})}</Typography>
                                            </MenuItem>
                                        ))}

                                    </Menu>
                                </Box>

                                <Box className="flex-grow items-center justify-evenly text-xl 2md:flex hidden">
                                    {pagesNav
                                    .filter((nav) => !disabledPages.includes(nav.name))
                                    .map((nav, index) => (
                                        <React.Fragment key={index}>
                                            <Button
                                                key={'but' + index}
                                                sx={{color: 'white', display: 'block', midWidth: '180px', height: '40px' }}
                                                className={currentNav === nav.name ? 'flex items-center font-sans text-white hover:text-black bg-secondary rounded-xl text-xxl normal-case' :  'flex items-center font-sans text-secondary text-xxl normal-case'}
                                                onClick={(event) => {
                                                    setAnchorElDynamic(event.currentTarget);
                                                    setOpenDynamic(nav.name)
                                                }}
                                            >
                                                {intl.formatMessage({id: nav.name})}
                                            </Button>
                                            <Menu
                                                key={'menu' + index}
                                                id="basic-menu-dynamic"
                                                anchorEl={anchorElDynamic}
                                                open={openDynamic === nav.name}
                                                onClose={() => {
                                                    setOpenDynamic(null)
                                                }}
                                                MenuListProps={{
                                                    'aria-labelledby': 'basic-button',
                                                }}
                                            >
                                                {renderSubs(nav.subs)}
                                            </Menu>
                                        </React.Fragment>
                                    ))}

                                </Box>

                                <Box sx={{ flexGrow: 0 }}>
                                    <Button
                                        key={'but5'}
                                        sx={{ color: 'white', display: 'block', maxWidth: '180px', height: '40px' }}
                                        className={currentNav === pagesAccNav[0].name ? 'hidden 2md:flex items-center font-sans text-white hover:text-black bg-blue-600 rounded-xl text-xxl capitalize truncate mr-24' :  'hidden 2md:flex items-center font-sans text-blue-600 text-xxl capitalize truncate mr-24'}
                                        onClick={handleOpenUserMenu}
                                    >
                                        {user?.talent?.first_name}
                                    </Button>
                                    <Menu
                                        sx={{ mt: '45px' }}
                                        id="menu-appbar"
                                        anchorEl={anchorElUser}
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        open={Boolean(anchorElUser)}
                                        onClose={handleCloseUserMenu}
                                    >
                                        {renderSubsAcc(pagesAccNav[0]?.subs)}
                                    </Menu>
                                </Box>
                            </Toolbar>
                        </Container>
                    </AppBar>
                </div>
                : '' }
            <AppRoutes/>
            {talent && talent?.profile_status != 'new' ?
                <footer className="py-4 mt-auto" style={{
                    boxShadow: "0px -2px 4px -1px rgba(0, 0, 0, 0.2), 0px -4px 5px 0px rgba(0, 0, 0, 0.14), 0px -1px 10px 0px rgba(0, 0, 0, 0.12)"
                }}>
                    <ul className="flex flex-col space-y-2 md:flex-row md:space-y-0 items-center justify-evenly">
                        {/* <li>
                            <a href={'#'} className="tawk_open" onClick={handleTawkTo}>
                                {intl.formatMessage({id: 'contact.us'})}
                            </a>
                        </li> */}

                        <li>
                            <a href={locale.short === "en" ? protectData_en : protectData_fr}
                               target="_blank" rel="noreferrer">{intl.formatMessage({id: 'protect.data'})}</a>
                        </li>

                        <li>
                            <a href={locale.short === "en" ? cguv_en : cguv_fr}
                               target="_blank" rel="noreferrer">{intl.formatMessage({id: 'cgu'})}</a>
                        </li>

                        <li>{name} &copy;</li>
                    </ul>
                </footer>
                : ''}

            {/* {showTalkTo ?
                <TawkMessengerReact propertyId={TawkToConfig.propertyId} widgetId={TawkToConfig.widgetId} ref={tawkMessengerRef}/>
            : ''}
            <CreateTicket />     */}
            {/* <LinkedInModal
                open={showLinkedInModalState}
                onClose={handleCloseLinkedInModal}
            /> */}
        </div>
    )
}

export default injectIntl(TalentLayout)
